<app-header></app-header>
<!-- <app-breadcrumb></app-breadcrumb> -->
<app-online-status
  [onlineStatusMessage]="connectionStatusMessage"
  [onlineStatus]="connectionStatus">
</app-online-status>
<router-outlet *ngIf="connectionStatus != 'offline'"></router-outlet>
<span title="Scroll to Top" [ngClass]="windowScrolled ? 'd-inline-block':''" (click)="scrollToTop()" class="scroll-to-target scroll-to-top"><i class="fa fa-angle-up"></i></span>

